import { Routes } from '@angular/router';
import { AuthenticationGuard } from './core/auth/authentication.guard';
import { roleGuard } from './services/core/auth/role.guard';
import { ForgotComponent } from './features/forgot/forgot.component';
import { NewpasswordComponent } from './features/newpassword/newpassword.component';
export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: 'login',
    loadComponent: () =>
      import('./features/login/login.component').then(m => m.LoginComponent)
  },
  
{ path: 'forgot/password', component: ForgotComponent },
 { path: 'new/password/:token', component: NewpasswordComponent },

    {
    path: 'public-profile/:id',
    loadComponent: () =>
      import('./features/public-profile-url/public-profile-url.component')
        .then(m => m.PublicProfileURLComponent)
  },
   {
    path: 'document-share-links/:id',
    loadComponent: () =>
      import('./features/user-share-links-view-document/user-share-links-view-document.component')
        .then(m => m.UserShareLinksViewDocumentComponent)
  },
  {
    path: 'portal',
    loadComponent: () =>
      import('./features/layout/layout.component').then(m => m.LayoutComponent),
     canActivate: [AuthenticationGuard],
    children: [
      { path: '',              redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
        // only employee can access 
        canActivate: [roleGuard],
        data: { roles: ['consumer'] }
      },
      {
        path: 'upload',
        loadComponent: () =>
          import('./features/upload/upload-document.component').then(m => m.UploadDocumentComponent),
        canActivate: [roleGuard],
        data: { roles: ['consumer'] }
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./features/settings/settings.component').then(m => m.SettingsComponent),
        canActivate: [roleGuard],
        data: { roles: ['consumer'] }
      },
{
        path: 'module',
        loadComponent: () =>
          import('./features/user-module-document/user-module-document.component').then(m => m.UserModuleDocumentComponent),
        canActivate: [roleGuard],
        data: { roles: ['consumer'] }
      },
      // {
      //   path: 'document_guide',
      //   loadComponent: () =>
      //     import('./features/app-navigation-guide/user-document-share-links-guide/user-document-share-links-guide.component').then(m => m.UserDocumentShareLinksGuideComponent),
      //   canActivate: [roleGuard],
      //   data: { roles: ['consumer'] }
      // },
      
{
        path: 'documents',
        loadComponent: () =>
          import('./features/users-documents-types/users-documents-types.component').then(m => m.UsersDocumentsTypesComponent),
        canActivate: [roleGuard],
        data: { roles: ['consumer'] }
      },
      {
        path: 'company-dashboard',
        loadComponent: () =>
          import('./features/company-dashboard/company-dashboard.component').then(m => m.CompanyDashboardComponent),
        canActivate: [roleGuard],
        data: { roles: ['consumer'] }
      },
       {
        path: 'document-share-links',
        loadComponent: () =>
          import('./features/user-document-share-links/user-document-share-links.component').then(m => m.UserDocumentShareLinksComponent),
        canActivate: [roleGuard],
        data: { roles: ['consumer'] }
      },
       {
        path: 'aelumni-memories',
        loadComponent: () =>
          import('./features/user-aelumni-memories/user-aelumni-memories.component').then(m => m.UserAelumniMemoriesComponent),
        canActivate: [roleGuard],
        data: { roles: ['consumer'] }
      },
       {
        path: 'employment-details',
        loadComponent: () =>
          import('./features/user-company-document/user-company-document.component').then(m => m.UserCompanyDocumentComponent),
        canActivate: [roleGuard],
        data: { roles: ['consumer'] }
      },

        // only admin can access

      {
        path: 'admin',
        loadComponent: () =>
          import('./features/admin/admin.component').then(m => m.AdminComponent),
        canActivate: [roleGuard],
        data: { roles: ['admin'] }
      },

      // company can access 

       {
        path: 'company',
        loadComponent: () =>
          import('./features/company/company.component').then(m => m.CompanyComponent),
        canActivate: [roleGuard],
        data: { roles: ['company'] }
      },

       {
        path: 'home',
        loadComponent: () =>
          import('./features/company/company-home/company-home.component').then(m => m.CompanyHomeComponent),
        canActivate: [roleGuard],
        data: { roles: ['company'] }
      },
    ]
  },
  { path: '**', redirectTo: 'login' }
];